module.exports = __webpack_public_path__ + "static/media/cape-cod-4.32cb83aa.jpg";